import { Navbar } from '../home/components/Navbar';
import { Footer } from '../home/components/Footer';

export default function ReturnsPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      {/* Hero */}
      <section className="relative pt-32 pb-20 px-6 bg-gradient-to-br from-[#6B0000] to-[#4A0000]">
        <div className="max-w-7xl mx-auto text-center">
          <span className="inline-block px-4 py-1.5 bg-white/10 text-white text-xs font-bold uppercase tracking-widest rounded-full mb-6">
            Customer Care
          </span>
          <h1 className="text-5xl md:text-6xl font-black text-white mb-6">
            Returns &amp; Exchanges
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto">
            We stand behind every shirt we print
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-20 px-6">
        <div className="max-w-4xl mx-auto space-y-12">
          {/* Our Guarantee */}
          <div className="bg-gradient-to-br from-[#6B0000] to-[#4A0000] rounded-2xl p-8 text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-white/10 rounded-full mx-auto mb-6">
              <i className="ri-shield-check-line text-3xl text-white"></i>
            </div>
            <h2 className="text-3xl font-black text-white mb-4">
              100% Satisfaction Guarantee
            </h2>
            <p className="text-lg text-white/90 max-w-2xl mx-auto">
              If there's a printing error, defect, or quality issue with your custom shirt, we'll reprint it for free or issue a full refund. Your satisfaction is our priority.
            </p>
          </div>

          {/* Custom Orders Policy */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-12 h-12 flex items-center justify-center bg-red-50 rounded-lg flex-shrink-0">
                <i className="ri-t-shirt-line text-2xl text-[#6B0000]"></i>
              </div>
              <div>
                <h2 className="text-2xl font-black text-gray-900 mb-2">
                  Custom Order Policy
                </h2>
                <p className="text-sm text-gray-600 mb-4">
                  Since every shirt is custom-made to your specifications, we cannot accept returns for:
                </p>
                <ul className="space-y-2 text-sm text-gray-600">
                  <li className="flex items-start gap-2">
                    <i className="ri-close-circle-line text-red-500 mt-0.5 flex-shrink-0"></i>
                    <span>Change of mind or buyer's remorse</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-close-circle-line text-red-500 mt-0.5 flex-shrink-0"></i>
                    <span>Design errors made by the customer during customization</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-close-circle-line text-red-500 mt-0.5 flex-shrink-0"></i>
                    <span>Incorrect size selection</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-close-circle-line text-red-500 mt-0.5 flex-shrink-0"></i>
                    <span>Color variations between screen display and printed product</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="bg-blue-50 rounded-lg p-4">
              <p className="text-sm font-bold text-blue-900">
                <i className="ri-lightbulb-line mr-2"></i>
                Tip: Always review your design carefully before placing your order. Our design studio shows you exactly what your shirt will look like!
              </p>
            </div>
          </div>

          {/* Eligible Returns */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-12 h-12 flex items-center justify-center bg-red-50 rounded-lg flex-shrink-0">
                <i className="ri-checkbox-circle-line text-2xl text-[#6B0000]"></i>
              </div>
              <div>
                <h2 className="text-2xl font-black text-gray-900 mb-2">
                  We'll Make It Right If:
                </h2>
                <p className="text-sm text-gray-600 mb-4">
                  We accept returns and offer free reprints or refunds for:
                </p>
                <ul className="space-y-2 text-sm text-gray-600">
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-green-500 mt-0.5 flex-shrink-0"></i>
                    <span>Printing errors or defects (smudges, misalignment, fading)</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-green-500 mt-0.5 flex-shrink-0"></i>
                    <span>Wrong design printed (our mistake)</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-green-500 mt-0.5 flex-shrink-0"></i>
                    <span>Damaged or defective garment</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-green-500 mt-0.5 flex-shrink-0"></i>
                    <span>Incorrect size shipped (our mistake)</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-green-500 mt-0.5 flex-shrink-0"></i>
                    <span>Package lost or damaged in transit</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Return Process */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
            <h2 className="text-2xl font-black text-gray-900 mb-6">
              How to Request a Return or Reprint
            </h2>
            <div className="space-y-6">
              <div className="flex gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-[#6B0000] text-white font-black rounded-full flex-shrink-0">
                  1
                </div>
                <div>
                  <h3 className="text-lg font-black text-gray-900 mb-1">
                    Contact Us Within 7 Days
                  </h3>
                  <p className="text-sm text-gray-600">
                    Email us at <a href="mailto:hello@ontargetprints.com" className="font-bold text-[#6B0000] hover:underline cursor-pointer">hello@ontargetprints.com</a> with your order number and photos of the issue.
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-[#6B0000] text-white font-black rounded-full flex-shrink-0">
                  2
                </div>
                <div>
                  <h3 className="text-lg font-black text-gray-900 mb-1">
                    We'll Review Your Request
                  </h3>
                  <p className="text-sm text-gray-600">
                    Our team will review your photos and order details within 24 hours.
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-[#6B0000] text-white font-black rounded-full flex-shrink-0">
                  3
                </div>
                <div>
                  <h3 className="text-lg font-black text-gray-900 mb-1">
                    Choose Your Solution
                  </h3>
                  <p className="text-sm text-gray-600">
                    We'll offer a free reprint with corrected design or a full refund — your choice!
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-[#6B0000] text-white font-black rounded-full flex-shrink-0">
                  4
                </div>
                <div>
                  <h3 className="text-lg font-black text-gray-900 mb-1">
                    Fast Resolution
                  </h3>
                  <p className="text-sm text-gray-600">
                    Reprints are prioritized and typically ship within 24-48 hours. Refunds are processed within 3-5 business days.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Exchanges */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-red-50 rounded-lg flex-shrink-0">
                <i className="ri-arrow-left-right-line text-2xl text-[#6B0000]"></i>
              </div>
              <div>
                <h2 className="text-2xl font-black text-gray-900 mb-2">
                  Size Exchanges
                </h2>
                <p className="text-sm text-gray-600 mb-4">
                  Need a different size? We'll work with you on a case-by-case basis. Contact us within 7 days of receiving your order. Exchange fees may apply for custom orders.
                </p>
                <p className="text-sm text-gray-600">
                  <strong className="text-gray-900">Pro tip:</strong> Check our size charts before ordering to ensure the perfect fit!
                </p>
              </div>
            </div>
          </div>

          {/* Contact CTA */}
          <div className="bg-red-50 rounded-2xl p-8 text-center border border-red-100">
            <h2 className="text-2xl font-black text-gray-900 mb-4">
              Have Questions About Returns?
            </h2>
            <p className="text-sm text-gray-600 mb-6">
              Our customer care team is here to help make things right.
            </p>
            <a
              href="/contact"
              className="inline-block px-8 py-4 bg-[#6B0000] text-white text-sm font-bold rounded-lg hover:bg-[#4A0000] transition-colors whitespace-nowrap cursor-pointer"
            >
              Contact Support
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}